/**
 * Created by Julio Perez on 5/24/2016.
 */

////ROUTING
import routing from './section-page.routes';

////CONTROLLER
import SectionPageController from './section-page.controller';

////DIRECTIVES
import sectionPage from './section-page.directive';

////SERVICES

export default angular
    .module('sectionPage', [
        sectionPage
    ])
    .config(routing)
    .controller('SectionPageController', SectionPageController)
    .name;


// WEBPACK FOOTER //
// ./src/app/views/section-page/index.js